import { Injectable } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { TenantOption } from '../models/tenantOption.model';
import { BaseApiService } from './base.api.service';

@Injectable({ providedIn: 'root' })
export class TenantOptionService  extends BaseApiService{
  listTenantOptions = ['tenantOptions'];

  getTenantOption(keyTenantOption: string) {
    return injectQuery(() => ({
      queryKey: ['tenantOptionByKey', keyTenantOption],
      queryFn: async () => {
        try {
          return await lastValueFrom(
            this.httpClient.get<TenantOption>(
              `${this.baseUrl}/api/core/TenantOptions/${keyTenantOption}`,
              {
                withCredentials: true,
              }
            )
          );
        } catch (error: any) {
          this.handleError(error);
          throw error;
        }
      },
    }));
  }

  getListTenantOption() {
    return injectQuery(() => ({
      queryKey: this.listTenantOptions,
      queryFn: async () => {
        try {
          return await lastValueFrom(
            this.httpClient.get<TenantOption[]>(
              `${this.baseUrl}/api/core/TenantOptions`,
              {
                withCredentials: true,
              }
            )
          );
        } catch (error: any) {
          this.handleError(error);
          throw error;
        }
      },
    }));
  }
}
